module.exports = __webpack_public_path__ + "img/JoeWahba_O_2.3dbf57d3.jpg";